<mat-form-field [class]="formFieldClass">
  <mat-label>{{ label }}</mat-label>
  <input
    type="text"
    matInput
    [formControl]="control"
    [matAutocomplete]="auto"
    [readonly]="isReadonly"
    [matAutocompleteDisabled]="isAutocompleteDisabled"
    (input)="onInput($event)" />
  <mat-autocomplete
    #auto="matAutocomplete"
    [displayWith]="displayLabel"
    [requireSelection]="requireSelection"
    (opened)="onAutocompleteOpened()"
    (optionSelected)="onOptionSelected()">
    @for (option of filteredOptions$ | async; track option.value) {
      <mat-option [value]="option.value">{{ option.label }}</mat-option>
    }
  </mat-autocomplete>
</mat-form-field>
